const SIGNUP_END_POINT = {
  APPLY: "/kiban/api/signup/apply",
  CHECK: "/kiban/api/signup/check",
  CREATE: "/kiban/api/user/create-minimal",
} as const

export default SIGNUP_END_POINT
